import ApiBase, { baseUrl } from '.';

export default class GroupServiceApi extends ApiBase {
  constructor(token) {
    super(`${baseUrl}/api/services/app/GroupService`, token);
  }

  getGroups(name = '', skipCount = 0, maxResultCount = 10) {
    return this.authHttp.get(`${this.baseUrl}/GetGroups`, {
      params: {
        Name: name,
        SkipCount: skipCount,
        MaxResultCount: maxResultCount
      }
    });
  }

  create(name, isActive) {
    return this.authHttp.post(`${this.baseUrl}/Create`, { name, isActive });
  }

  update(id, name, isActive) {
    return this.authHttp.put(`${this.baseUrl}/Update`, { id, name, isActive });
  }

  delete(id) {
    return this.authHttp.delete(`${this.baseUrl}/Delete`, { params: { id } });
  }

  get(id) {
    return this.authHttp.get(`${this.baseUrl}/Get`, { params: { id } });
  }

  getAssignedCourses(id, name, skip, take) {
    return this.authHttp.get(`${this.baseUrl}/GetAssignedCourses`, {
      params: { groupId: id, name: name, skipCount: skip, maxResultCount: take }
    });
  }

  getUnassignedCourses(id, query, take = 6) {
    return this.authHttp.get(`${this.baseUrl}/GetUnassignedCourses`, {
      params: { groupId: id, name: query, maxResultCount: take }
    });
  }

  getAssignedUsers(id, name, skip, take) {
    return this.authHttp.get(`${this.baseUrl}/GetAssignedUsers`, {
      params: { groupId: id, name: name, skipCount: skip, maxResultCount: take }
    });
  }

  getUnassignedUsers(id, query, take = 6) {
    return this.authHttp.get(`${this.baseUrl}/GetUnassignedUsers`, {
      params: { groupId: id, name: query, maxResultCount: take }
    });
  }

  assignUsersToGroup(id, userIds) {
    return this.authHttp.post(`${this.baseUrl}/AssignUsersToGroup`, {
      groupId: id,
      userIds: userIds
    });
  }

  unAssignUsersFromGroup(id, userIds) {
    return this.authHttp.post(`${this.baseUrl}/UnAssignUsersFromGroup`, {
      groupId: id,
      userIds: userIds
    });
  }

  assignCoursesToGroup(id, courseIds, dateFrom = null, dateTo = null, keepCourseOngoing=false) {
    return this.authHttp.post(`${this.baseUrl}/AssignCoursesToGroup`, {
      groupId: id,
      courseIds: courseIds,
      dateFrom,
      dateTo,
      keepCourseOngoing
    });
  }

  unAssignCoursesFromGroup(id, courseIds) {
    return this.authHttp.post(`${this.baseUrl}/UnAssignCoursesFromGroup`, {
      groupId: id,
      courseIds: courseIds
    });
  }

  updateCourseAssignment(courseAssignmentId, dateFrom, dateTo, keepCourseOngoing) {
    return this.authHttp.put(`${this.baseUrl}/UpdateCourseAssignment`, {
      courseAssignmentId,
      dateFrom,
      dateTo,
      keepCourseOngoing
    });
  }

  sendMailingForGroup(title, body, groupId = null, userIds = []) {
    return this.authHttp.post(`${this.baseUrl}/SendMailingForGroup`, {
      title,
      body,
      groupId,
      userIds
    });
  }

  getAssignedUsersCourseResults(groupId, courseId, keyword, skip, take) {
    return this.authHttp.get(`${this.baseUrl}/GetAssignedUsersCourseResults`, {
      params: { groupId, courseId, keyword, skipCount: skip, maxResultCount: take }
    });
  }

  removeAssignedUserCourseResult(courseExecutionId, userId, groupId, courseId) {
    return this.authHttp.delete(`${this.baseUrl}/RemoveAssignedUserCourseResult`, {
      params: {
        courseExecutionId,
        userId,
        groupId,
        courseId
      }
    });
  }
}
